export default __webpack_public_path__ + "static/media/WeatherDash.49982a62.png";